<template>
    <div class="list-container">
        <div class="title-row">
            <div class="header-group">
                <h1 class="title">{{ $t('talk.feedbacks') }}</h1>
                <tabs
                    size="md"
                    module="roles"
                    :tabs="availableTabs"
                    :loading="isLoading"
                    @tabChange="onRoleTabChanged"
                    v-if="canViewTabs"
                />
            </div>
            <filters @changed="applyFilter" :selectedRoleTab="currentRoleTab" />
        </div>
        <dashboard />
        <feedbacks-header
            @tabChanged="onTabChangedHandler"
            :pendingCount="pendingCount"
            :loading="isLoading"
            :roleTab="currentRoleTab"
        />
        <div class="list">
            <loader class="mt-3" :loader="isLoading" v-if="isLoading" />
            <div v-if="!isLoading">
                <div v-if="feedbacks.length == 0">
                    <b-alert show>{{
                        $t('talk.noFeedbacksList', {
                            type: $t(
                                'talk.feedback.types.' + this.currentTab
                            ).toLowerCase(),
                        })
                    }}</b-alert>
                </div>
                <div v-if="feedbacks.length > 0">
                    <feedback
                        v-for="feedback in feedbacks"
                        :key="'feedback-' + feedback.id"
                        :feedback="feedback"
                        :type="currentTab"
                        :role="currentRoleTab"
                        @reloadFeedbacks="reloadFeedbacksInfo()"
                    />
                </div>
            </div>
        </div>
        <b-pagination
            class="mb-0"
            :disabled="isLoading"
            :total-rows="pagination.total"
            :per-page="pagination.perPage"
            v-model="pagination.currentPage"
            @change="getFeedbacksFromApi($event)"
        />
        <router-view></router-view>
    </div>
</template>
<script>
import { EventBuzz } from '@/main'
import { getFeedbacks, getCount } from './api'
import Loader from '@/views/components/loader'
import { FeedbacksHeader, Feedback, Dashboard, Filters } from './components'
import Tabs from '@/views/components/tabs'
import data from './data'
import availableTabsMixin from './availableTabsMixin'

export default {
    name: 'List',
    components: {
        FeedbacksHeader,
        Feedback,
        Loader,
        Dashboard,
        Filters,
        Tabs,
    },
    mixins: [availableTabsMixin],
    data() {
        return {
            isLoading: false,
            currentUser: this.$store.state.currentUser.user,
            feedbacks: [],
            currentTab: 'received',
            currentRoleTab: 'user',
            pagination: {
                total: null,
                perPage: 10,
                from: null,
                to: null,
                currentPage: 1,
            },
            pendingCount: 0,
            filters: {},
            ...data(),
        }
    },
    mounted() {
        EventBuzz.$on('update-talk-summary', this.getFeedbacksFromApi)
        this.reloadFeedbacksInfo()
        this.parseAvailableTabs().then(() => {
            this.tabs.map((t) => {
                if (t.id === this.currentRoleTab) {
                    t.active = true
                }

                return t
            })
        })
    },
    computed: {
        canViewTabs() {
            return this.availableTabs.length > 1
        },
    },
    methods: {
        getFeedbacksFromApi(page = 1) {
            this.isLoading = true
            getFeedbacks(
                this.currentUser.id,
                this.currentTab,
                page,
                this.filters,
                this.currentRoleTab
            )
                .then(({ from, to, total, data, per_page, current_page }) => {
                    this.feedbacks = data
                    this.pagination = {
                        from,
                        to,
                        total,
                        perPage: per_page,
                        currentPage: current_page,
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        onTabChangedHandler(tab) {
            this.currentTab = tab
            this.reloadFeedbacksInfo()
        },
        reloadFeedbacksInfo() {
            this.getFeedbacksFromApi()
            this.getPendingCountFromApi()
        },
        getPendingCountFromApi() {
            getCount(
                this.currentUser.id,
                this.filters,
                ['pending'],
                this.currentRoleTab
            )
                .then(({ pending }) => {
                    if (!pending) {
                        return
                    }
                    this.pendingCount = pending.total
                })
                .catch((error) => console.log(error))
        },
        applyFilter(filters) {
            this.filters = filters
            this.reloadFeedbacksInfo()
        },
        onRoleTabChanged(tab) {
            this.currentRoleTab = tab
            this.handleFiltersByTab()
            EventBuzz.$emit('roleChanged', tab)
        },
        handleFiltersByTab() {
            if (this.currentRoleTab !== 'administrator') {
                this.clearFilterForNonAdmin()
            }
            if (this.currentRoleTab === 'user') {
                this.clearFilterForUser()
            }
        },
        clearFilterForNonAdmin() {
            this.filters = {
                ...this.filters,
                departments: null,
                managers: null,
                occupationGroups: null,
            }
        },
        clearFilterForUser() {
            this.filters = {
                ...this.filters,
                bulkSearch: null,
            }
        },
    },
}
</script>
<style lang="sass" scoped>
.title-row
    display: flex
    margin: 0
    justify-content: space-between
    flex-direction: column
    align-items: center
    .header-group
        display: flex
        justify-content: flex-start
        align-items: center
    .title
        color: #6f6f6f
        font-size: 24px
        font-weight: 500

.list-container
    background-color: #fff
    min-height: 30vh
    padding: 20px
    .list
        margin-bottom: 40px
.no-feedbacks
    color: #6f6f6f
    margin: 60px 0
    display: block
@media (min-width: 600px)
    .list-container
        padding: 10px 60px 20px 60px
@media (min-width: 768px)
    .title-row
        flex-direction: row
</style>
